<script>
import BaseMap from '@/components(new)/UI/Maps/BaseMap/BaseMap.vue'
import SustainablePracticesManager from '@/components(new)/UI/Maps/core/sustainablePracticesManager.js'
import PracticesTable from '@/components(new)/UI/Tables/PracticesTable/PracticesTable.vue'
import VectorizationMenu from './VectorizationMenu/VectorizationMenu.vue'
import { isPointInsideFeature } from '../core/utils'
import { polygon, booleanEqual } from '@turf/turf'
import _ from 'lodash'

export default {
  components: {
    BaseMap,
    PracticesTable,
    VectorizationMenu
  },
  emits: ['updateAreas', 'renderPratices'],
  props: {
    pratices: {
      type: Array,
      required: true,
      default: () => []
    },
    propertyShapeImovel: {
      type: Object,
      required: true
    },
    onlyView: {
      default: false
    }
  },
  data () {
    return {
      mapManager: null,
      columns: [
        {
          label: 'Legenda',
          key: 'legend',
          width: '70px',
          align: 'center'
        },
        {
          label: 'Área (ha)',
          key: 'area',
          width: '80px',
          align: 'center'
        },
        {
          label: 'Área vetorizada (ha)',
          key: 'vectorizedArea',
          align: 'center'
        },
        {
          label: 'Nome',
          key: 'name'
        },
        {
          label: 'Ações',
          key: 'actions',
          width: '70px',
          align: 'center'
        }
      ],
      currentSP: null,
      drawnArea: 0,
      hasDrawing: false,
      vectorizedSps: {},
      clickedSpLayer: null
    }
  },
  beforeMount () {
    if (!this.onlyView) {
      this.columns = this.columns.filter(c => c.key !== 'vectorizedArea')
    }
  },
  mounted () {
    if (!this.mapManager?.map) {
      this.initMapa()
    }
  },
  activated () {
    if (!this.mapManager?.map) {
      this.initMapa()
    }
    this.resetSpsData()
  },
  computed: {
    sustainablePractices () {
      const actions = {
        draw: { key: 'draw', label: 'Vetorizar área', icon: 'pencil-alt', type: 'default' },
        edit: { key: 'edit', label: 'Editar', icon: 'check', type: 'success' }
      }

      const imovel = {
        area: this.onlyView ? '-' : this.propertyShapeImovel.vectorizedArea,
        id: 'IMOVEL',
        legend: '#ffff00',
        name: 'Imóvel',
        tolerance: 0.3,
        vectorizedArea: this.propertyShapeImovel.vectorizedArea,
        actions: {
          ...actions.edit,
          disabled: true
        }
      }
      return [imovel, ...this.pratices.map((pratice) => ({
        ...pratice,
        actions: this.vectorizedSps[pratice.id] ? actions.edit : actions.draw
      }))]
    }
  },
  methods: {
    initMapa () {
      this.mapManager = new SustainablePracticesManager(this.$refs.baseMap.mapManager)
      this.mapManager.importShape(this.propertyShapeImovel)
      this.pratices.forEach((shape) => {
        if (shape.geometry.features) {
          if (shape.geometry.features.length > 1) {
            shape.geometry.features.forEach((feature) => {
              const s = {
                ...shape,
                geometry: {
                  ...shape.geometry,
                  features: [feature]
                }
              }
              this.mapManager.importShapeSaved(s)
            })
          } else {
            this.mapManager.importShapeSaved(shape)
          }
          this.$set(this.vectorizedSps, shape.id, {
            ...shape,
            layers: shape.geometry.features
          })
        }
      })

      this.$emit('updateAreas', this.vectorizedSps)
      this.mapManager.map.on('draw:created', this.handleDrawCreated)
      this.mapManager.map.on('click', this.mapClickCb)
    },
    editSP (evt) {
      if (evt.actions.key === 'edit') {
        this.drawnArea = Number(this.vectorizedSps[evt.id].vectorizedArea)
        this.hasDrawing = true
        this.mapManager.currentSP = evt
      }
      this.currentSP = evt
    },
    handleVectorizationAction (evt) {
      const actions = {
        initVectorization: this.initiVetorization,
        deleteVectorization: this.deleteVectorization,
        deleteVectorizationPolygon: this.deleteVectorizationPolygon,
        backToTable: this.backToTable,
        importShape: this.importShape,
        submitForm: this.updateVectorizedSps
      }

      actions[evt.type]()
    },
    initiVetorization () {
      this.mapManager.initVectorization(this.currentSP)
    },
    resetSpsData () {
      this.currentSP = null
      this.hasDrawing = false
      this.drawnArea = 0
    },
    handleDrawCreated (e) {
      const { ha } = this.mapManager.handleDrawCreated(e)
      this.hasDrawing = true
      this.drawnArea = ha
    },
    deleteVectorization () {
      delete this.vectorizedSps[this.currentSP.id]
      this.$emit('renderPratices')
      this.currentSP.geometry = null
      this.mapManager.deleteVectorization(this.currentSP)
      this.hasDrawing = false
      this.drawnArea = 0
    },
    deleteVectorizationPolygon () {
      const layers = this.mapManager.getCurrentSpLayers()

      const indexLayer = layers
        .findIndex(layer => booleanEqual(polygon(layer.geometry.coordinates), polygon(this.clickedSpLayer.geometry.coordinates)))

      if (indexLayer !== -1) {
        layers.splice(indexLayer, 1)
      }

      if (!layers?.length) {
        delete this.vectorizedSps[this.currentSP.id]
        this.$emit('renderPratices')
        this.currentSP.geometry = null
        this.mapManager.deleteVectorization(this.currentSP)
        this.hasDrawing = false
        this.drawnArea = 0
        return
      }

      this.$emit('renderPratices')

      const { ha } = this.mapManager.deleteVectorizationPolygon(this.clickedSpLayer, this.currentSP)

      if (this.vectorizedSps[this.currentSP.id]?.geometry) {
        this.vectorizedSps[this.currentSP.id].geometry.features = [...layers]
        this.vectorizedSps[this.currentSP.id].layers = [...layers]
        this.vectorizedSps[this.currentSP.id].vectorizedArea = ha.toString()

        this.currentSP = _.cloneDeep(this.vectorizedSps[this.currentSP.id])
        delete this.currentSP.layers
      }

      this.drawnArea = ha
    },
    async importShape () {
      this.mapManager.currentSP = this.currentSP
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.geojson,.kml,.zip'
      input.click()

      input.addEventListener('change', async (e) => {
        const file = e.target.files[0]
        const { ha } = await this.mapManager.importShape(file)
        this.hasDrawing = true
        this.drawnArea = ha
      })
    },
    updateVectorizedSps () {
      this.$set(this.vectorizedSps, this.currentSP.id, {
        ...this.currentSP,
        layers: this.mapManager.getCurrentSpLayers(),
        vectorizedArea: this.drawnArea
      })

      this.$emit('updateAreas', this.vectorizedSps)

      this.resetSpsData()
    },
    backToTable () {
      if (!this.vectorizedSps[this.currentSP.id]) {
        this.deleteVectorization(this.currentSP)
      }
      this.resetSpsData()
      this.initMapa()
    },
    mapClickCb (e) {
      this.clickedSpLayer = null
      if (!this.mapManager.getCurrentSpLayers()?.length) {
        this.clickedSpLayer = null
      }
      this.mapManager.getCurrentSpLayers().forEach(layer => {
        if (isPointInsideFeature(e.latlng, layer)) {
          this.clickedSpLayer = layer
        }
      })
      if (this.clickedSpLayer && this.$refs.vectorizationMenu.deleteActive) {
        this.$refs.vectorizationMenu.deleteDrawingPolygon()
      }
    },
    removePraticaFromVectorizedSps (codigoPratica) {
      Object.keys(this.vectorizedSps).forEach(id => {
        const pratica = this.vectorizedSps[id]
        if (pratica && pratica.codigo === codigoPratica) {
          delete this.vectorizedSps[id]
        }
      })
      this.$emit('updateAreas', this.vectorizedSps)
    },
    cleanVectorizedSpsForRemovedPractices () {
      const praticasIds = this.pratices.map(p => p.id)
      Object.keys(this.vectorizedSps).forEach(id => {
        if (!praticasIds.includes(id)) {
          delete this.vectorizedSps[id]
        }
      })
      this.$emit('updateAreas', this.vectorizedSps)
    }
  },
  watch: {
    pratices: {
      handler () {
        this.cleanVectorizedSpsForRemovedPractices()
      },
      deep: true
    }
  },
  expose: ['removePraticaFromVectorizedSps', 'cleanVectorizedSpsForRemovedPractices']
}
</script>

<template>
  <div class="sedap-sustainable-practices-map">
    <div class="sedap-sustainable-practices-map__table">
      <PracticesTable
        v-if="!currentSP"
        :tableData="sustainablePractices"
        :columns="columns"
        :onlyView="onlyView"
        stripe
        title="Vetorização de áreas com SPs"
        @onAction="editSP"
      />
      <VectorizationMenu
        v-else
        ref="vectorizationMenu"
        :sp="currentSP"
        :drawnArea="drawnArea"
        :hasDrawing="hasDrawing"
        @onAction="handleVectorizationAction"
      />
    </div>
    <BaseMap :id="'sedap-map-georreferenciamento'" ref="baseMap"/>
  </div>
</template>

<style lang="scss">
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Maps/SustainablePracticesMap/SustainablePracticesMap.vue